module.exports = __webpack_public_path__ + "static/media/49-iveco.aa7434de.jpg";